import t from 'react-translate';
import { useContext } from 'react';
import NvIcon from 'shared/components/nv-icon';
import { css } from '@emotion/react';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';
import AiConversationContext, { Role, VoiceCardState, VoiceRecordingState } from '../context';
import VoiceCard from './voice-card';
import useViewedSubmission from '../use-viewed-submission';
import useAiRolePlay from '../../hooks/use-ai-role-play';

const styles = css`
  .voice-cards {
    gap: ${doubleSpacing}px;
  }
`;

const VoiceCardsContainer = () => {
  const {
    aiRolePlayId,
    aiVoiceCardState,
    learnerVoiceCardState,
    learnerMediaStream,
    voiceRecordingState,
    microphoneEnabled,
  } = useContext(AiConversationContext);
  const aiRolePlay = useAiRolePlay(aiRolePlayId);
  const { profile } = useViewedSubmission();

  return (
    <div css={styles} className='d-flex flex-column'>
      <div className='d-flex justify-content-center voice-cards'>
        {microphoneEnabled && (
          <VoiceCard
            role={Role.AI}
            name={aiRolePlay?.aiCharacterName}
            state={aiVoiceCardState ?? VoiceCardState.IDLE}
          />
        )}
        <VoiceCard
          role={Role.LEARNER}
          name={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOU()}
          state={learnerVoiceCardState ?? VoiceCardState.IDLE}
          profile={profile}
          mediaStream={learnerMediaStream ?? undefined}
        />
      </div>
      {!microphoneEnabled && voiceRecordingState !== VoiceRecordingState.COUNTDOWN && (
        <div className='d-flex mt-6 justify-content-center'>
          <NvIcon
            icon='info'
            className='d-flex align-items-center text-black'
            size='small'
          />
          <p
            className='mb-0 text-black text-regular ml-2'
          >
            {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.CHECK_MICROPHONE()}
          </p>
        </div>
      )}
    </div>
  );
};

export default VoiceCardsContainer;
